var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.50996 1.08449C9.50996 3.44782 10.756 4.63582 11.8293 5.76515C12.856 6.84515 13.8333 7.87382 13.8333 9.83315C13.8333 13.0412 11.3313 15.3332 8.12329 15.3332C4.91463 15.3332 2.16663 13.0525 2.16663 9.83315C2.16663 8.47382 2.80796 7.15915 3.83929 6.56715C4.04263 6.45049 4.28729 6.57182 4.37463 6.78982C5.04196 8.45582 5.86463 8.42649 6.29129 7.99982C6.54996 7.74182 6.60463 7.25582 6.28863 6.62515C4.68529 3.41715 7.53063 1.10582 9.08863 0.722488C9.31263 0.667821 9.49863 0.854488 9.50996 1.08449ZM8.12329 14.3332C10.8293 14.3332 12.8333 12.4398 12.8333 9.83315C12.8333 8.27515 12.1046 7.50715 11.048 6.39449L11.034 6.37915C10.074 5.36782 8.94129 4.14515 8.60129 2.00782C8.09789 2.30372 7.66353 2.70376 7.32729 3.18115C6.80263 3.94382 6.56263 4.93649 7.18329 6.17782C7.58529 6.98115 7.70129 8.00449 6.99863 8.70715C6.56063 9.14515 5.82396 9.44049 5.02796 9.09782C4.52663 8.88182 4.12596 8.46115 3.80263 7.90449C3.42463 8.37515 3.16663 9.06449 3.16663 9.83315C3.16663 12.3978 5.35863 14.3332 8.12329 14.3332Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawHot);
export default __webpack_public_path__ + "static/media/draw-hot.7dbf709226d2397f81188706fb5a7895.svg";
export { ForwardRef as ReactComponent };